export enum HtmlEditorType {
  paragraph = 'paragraph',
  heading = 'heading',
}
